import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	toggleButton: {
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '4px',
		marginRight: '8px',
		':hover': {
			opacity: 0.7,
		},
		':focus': {
			outline: 'none',
			opacity: 0.7,
		},
	},
});
